import { gql } from '@apollo/client';

export const USER = gql`
    query User($id: ID) {
        user(id: $id) {
            id
            fullName
            lastName
            firstName
            email
            hasVerifiedEmail
            phoneNumber
            hasVerifiedPhoneNumber
            phoneNumberPrefix
            birthdate
            gender
            photoUrl
            locale
            notificationType
            permissions
            role {
                id
                name
            }
            company {
                id
                name
                postalCode
                city
                footer
                applications {
                    id
                    name
                    pivot {
                        expiration
                    }
                }
            }
            companies {
                id
                name
            }
        }
    }
`;
